import { FinesProvider } from 'context/FinesContext';
import MainLayout from 'layouts/MainLayout';
import Dashboard from 'pages/dashboard/Dashboard';
import Reports from 'pages/finance/Reports';
import Revenue from 'pages/finance/Revenue';
import Fines from 'pages/Fines';
import FineDetails from 'pages/Fines/SingleFine';
import Profile from 'pages/profile';
import Sms from 'pages/sms';
import Violations from 'pages/Violations';
import React, { useEffect } from 'react';
import { Outlet, Route, Navigate } from 'react-router-dom';
import Finance from 'pages/finance';
import {
  addAuthInterceptor,
  axiosInstance,
  axiosInstance2,
} from 'hooks/auth/AxiosInstance';
import { useKeycloak } from '@react-keycloak/web';
import PrivateRoute from './PrivateRoutes';
import ViolationDetails from 'pages/Violations/SingleViolation';
import NTSADashboard from 'pages/ntsa/dashboard';
import NTSAFinesList from 'pages/ntsa/fines';
import NTSAFineDetails from 'pages/ntsa/details';

const MainRoutes = () => {
  const { keycloak } = useKeycloak();
  const client =
    process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'api-service-client';
  const isNTSAUser =
    keycloak.tokenParsed?.resource_access?.[client]?.roles?.includes('ntsa');
  useEffect(() => {
    addAuthInterceptor(axiosInstance, keycloak);
    addAuthInterceptor(axiosInstance2, keycloak);
  }, []);
  return (
    <>
      <Route element={<MainLayout />}>
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/sms" element={<Sms />} />
          <Route path="/violations/single/:id" element={<ViolationDetails />} />
          <Route path="/violations/:page" element={<Violations />} />
          <Route
            path="/violations"
            element={<Navigate to="/violations/1" replace />}
          />
          <Route path="/profile" element={<Profile />} />
          <Route path="/finance/overview" element={<Finance />} />
          <Route path="/finance/revenue" element={<Revenue />} />
          <Route path="/finance/transactions/:page" element={<Reports />} />
          <Route
            path="/finance/transactions"
            element={<Navigate to="/finance/transactions/1" replace />}
          />
        </Route>

        <Route
          path="/fines/*"
          element={
            <FinesProvider>
              <Outlet />
            </FinesProvider>
          }
        >
          <Route path="dashboard" element={<NTSADashboard />} />

          <Route
            path=":page"
            element={isNTSAUser ? <NTSAFinesList /> : <Fines />}
          />

          <Route
            path="single/:id"
            element={isNTSAUser ? <NTSAFineDetails /> : <FineDetails />}
          />

          <Route
            index
            element={
              <Navigate
                to={isNTSAUser ? '/fines/dashboard' : '/fines/1'}
                replace
              />
            }
          />
        </Route>
      </Route>
    </>
  );
};
export default MainRoutes;
